<style lang="less">
  @em: (20);
  .score-label {
    border: 1PX solid rgb(255, 82, 82) !important;
    border-radius: 3rem/@em !important;
    line-height: 14rem/@em !important;
    padding: 0 5rem/@em !important;
    margin: 0;
    height: 14rem/@em !important;
    display: inline-block !important;
    text-align: center !important;
    color: rgb(255, 82, 82) !important;
    position: relative;
    top: -1PX;
    max-width: 90rem/@em;
    text-overflow:ellipsis !important;
    font-size: 12rem/@em !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }

  .courseHeader-con .info .info-left .right {
    position: relative;
    .score-label {
      left: 2rem !important;
      top: 1rem/@em !important;
      position: absolute !important;
      max-width: 4.5rem !important;
    }
  }
  .price {
    .score-label {
      top: 0.5rem !important;
      position: absolute !important;
      max-width: 150rem/@em !important;
      padding: 0 5rem/@em !important;
    }

    .score-label.middle {
      top: 0.9rem !important;
    }
  }
</style>

<template>
  <span class="score-label" v-if="data">
    {{ desc }}
  </span>
<!--     <span class="score-label" tilte="1000积分可抵￥1.1">1000积分可抵￥1.1</span> -->
</template>

<script>
export default {
  name: 'ScoreLabel',
  data() {
    return {};
  },
  computed: {
    desc() {
      return this.type === 'detail' ? this.data.zhDetailDesc : this.data.zhListDesc;
    }
  },
  props: ['data', 'type'],
  methods: {},
  create() {
    if (this.type === 'detail') {
      document.querySelector('.price del').style.display = 'inline-block';
    }
  },
  mounted() {
    if (document.querySelector('.price del') && this.data) {
      if (this.type === 'detail' && this.data) {
        document.querySelector('.price del').style.display = 'none';
      } else {
        document.querySelector('.price del').style.display = 'inline-block';
      }
    }
  },
  watch: {
    data() {
      if (document.querySelector('.price del') && this.data) {
        if (this.type === 'detail' && this.data) {
          document.querySelector('.price del').style.display = 'none';
        } else {
          document.querySelector('.price del').style.display = 'inline-block';
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ScoreLabel.vue?cfc9fe66